import axios from 'axios';
import { transfomer } from "../helpers/transformers";
import { url } from "../helpers/urls";
//import config from 'config';
//import { authHeader } from '../helpers/auth-header';

export const turnoService = {
  findSedes, //todos las sedes
  findBySede, //busqueda de turnos por médico
  reservarTurno,
  reservarTurnoTeyuna,
  getHorarioAtencion,
  findByServicio,
  findByClasificacionSedeServicio,
  findByTurnoClasificacion,
  verificarKit,
  verificarCategoria,
  findSedesByZona,
  findFechaKit,
  findFechaReservacion,
  verificaTeyuna,
  findHoraByFecha,
  findSedeByFecha,
  findByTurnoClasificacionKIT,
  findZonaKit,
  findSedeByZona,
  verificarCuota,
  verificarNuevoMedio,
  verificaHorarioCuota,
  findByClasificacionCuota,
  findByClasificacionNuevoMedio
};

function findSedes() {
  const requestOptions = {
    method: 'GET',
    url: `${url}/sedes`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findSedesByZona(codzon) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/sedesByZona`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
     data: {
      codzon: codzon
    }
  };
  return axios(requestOptions).then(response =>
      transfomer.selectFormat(response.data.data)
  )
}

function getHorarioAtencion(){
  const requestOptions = {
    method: 'GET',
    url: `${url}/horario`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
     response.data
  )
}

function findBySede(sede) {
  const requestOptions = {
    method: 'GET',
    url: `${url}/turnos/sede/${sede}`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByServicio(servicio) {
  const requestOptions = {
    method: 'GET',
    url: `${url}/turnos/clasificacion/${servicio}`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByClasificacionSedeServicio(sede, servicio) {
  const requestOptions = {
    method: 'GET',
    url: `${url}/clasificacion/${sede}/${servicio}/E`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByClasificacionCuota() {
  const requestOptions = {
    method: 'GET',
    url: `${url}/clasificacion/cuota`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByClasificacionNuevoMedio() {
  const requestOptions = {
    method: 'GET',
    url: `${url}/tramite/nuevo/medio`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByTurnoClasificacion(clasificacion) {
  const requestOptions = {
    method: 'GET',
    url: `${url}/TurnoClasificacion/${clasificacion}/E`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };
  return axios(requestOptions).then(response =>
     response.data
  )
}

function reservarTurno(turnoId, documento, celular, email, tramite, codins = false) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/solicitar`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      turno: turnoId,
      documento: documento,
      celular: celular,
      email: email,
      tramite: tramite,
      codins: codins
    }
  };
  return axios(requestOptions).then(response =>
    response
  )
}

function reservarTurnoTeyuna(documento, celular, email, participantes, dia, particulares, servicio, categoria, nombreServicio) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/teyuna`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      documento: documento,
      celular: celular,
      email: email,
      participante: participantes,
      dia: dia,
      particulares : particulares,
      servicio: servicio,
      categoria: categoria,
      nombreServicio: nombreServicio,
    }
  };
  return axios(requestOptions).then(response =>
    response.data
  )
}

function verificaTeyuna(documento, dia) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/verifica/teyuna`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      documento: documento,
      dia: dia
    }
  };
  return axios(requestOptions).then(response =>
    response.data
  )
}


function verificaHorarioCuota(documento, dia) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/verifica/teyuna/horario`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      documento: documento,
      dia: dia
    }
  };
  return axios(requestOptions).then(response =>
    response.data
  )
}

function verificarKit(info) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/verificarKit`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      info
    }
  };
  return axios(requestOptions).then(response =>
    response
  )
}


function verificarCategoria(info) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/verificarCategoria`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      info
    }
  };
  return axios(requestOptions).then(response =>
    response
  )
}

function verificarCuota(info) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/verificarCuota`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      info
    }
  };
  return axios(requestOptions).then(response =>
    response
  )
}

function verificarNuevoMedio(info) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/verificarMedioPago`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      info
    }
  };
  return axios(requestOptions).then(response =>
    response
  )
}

function findFechaKit(sede) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/fechaKit`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }, 
    data: {
      sede: sede
    }
  };
  return axios(requestOptions).then(response =>
      transfomer.selectFormat(response.data.data)
  )
}

function findFechaReservacion() {
  const requestOptions = {
    method: 'POST',
    url: `${url}/fechaReservacion`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }
  };
  return axios(requestOptions).then(response =>
      transfomer.selectFormat(response.data.data)
  )
}

function findHoraByFecha(fecha, servicio) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/hora`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      dia: fecha,
      servicio: servicio
    }
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findSedeByFecha(servicio, hora) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/turnos/sede`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data: {
      servicio: fecha,
      hora: hora
    }
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}

function findByTurnoClasificacionKIT(sede, servicio, clasificacion) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/Turnos/Kit`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data:{
      sede: sede, 
      servicio: servicio, 
      clasificacion: clasificacion
    }
  };
  return axios(requestOptions).then(response =>
     response.data
  )
}

function findZonaKit() {
  const requestOptions = {
    method: 'POST',
    url: `${url}/kit/zona`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}



function findSedeByZona(zona, bono, zonaBono) {
  const requestOptions = {
    method: 'POST',
    url: `${url}/sede/zona`,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    data:{
      zona: zona, 
      bono: bono, 
      zonaBono: zonaBono
    }
  };
  return axios(requestOptions).then(response =>
    transfomer.selectFormat(response.data.data)
  )
}


// WEBPACK FOOTER //
// ./src/services/turnoService.js